var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_866_14839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84276 8.30713L1.94018 12.1732C1.82623 12.2863 1.73579 12.4207 1.67407 12.5689C1.61234 12.717 1.58057 12.8759 1.58057 13.0364C1.58057 13.1969 1.61234 13.3558 1.67407 13.504C1.73579 13.6521 1.82623 13.7866 1.94018 13.8996L4.51759 16.477C4.63061 16.591 4.76507 16.6814 4.91322 16.7431C5.06137 16.8048 5.22028 16.8366 5.38077 16.8366C5.54127 16.8366 5.70017 16.8048 5.84832 16.7431C5.99647 16.6814 6.13094 16.591 6.24396 16.477L10.1101 12.5744",
    stroke: "#323232",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1374 9.54731L17.0035 5.68121C17.1175 5.56819 17.2079 5.43373 17.2696 5.28558C17.3314 5.13743 17.3631 4.97852 17.3631 4.81803C17.3631 4.65753 17.3314 4.49863 17.2696 4.35048C17.2079 4.20233 17.1175 4.06786 17.0035 3.95484L14.4626 1.37744C14.3496 1.26349 14.2151 1.17304 14.067 1.11132C13.9188 1.0496 13.7599 1.01782 13.5994 1.01782C13.4389 1.01782 13.28 1.0496 13.1318 1.11132C12.9837 1.17304 12.8492 1.26349 12.7362 1.37744L8.87012 5.28001",
    stroke: "#323232",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9216 6.49585L7.05859 11.3589",
    stroke: "#323232",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_866_14839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0206,
    height: 17.0206,
    fill: "white",
    transform: "translate(0.97998 0.416992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.dbb550295d55d8ee548ac51382c3c6b4.svg";
export { ForwardRef as ReactComponent };